import { render, staticRenderFns } from "./Administrativo.vue?vue&type=template&id=3b7717d8&"
import script from "./Administrativo.vue?vue&type=script&lang=ts&"
export * from "./Administrativo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports